import IntegrationPairingLogo from './IntegrationPairingLogo';

export default IntegrationPairingLogo;
